import { useRef as r } from "react";

import { useSyncExternalStore as t } from "use-sync-external-store/shim";

const e = (e, o) => {
    const n = r().current ||= () => o(e);
    return t(e.on, n, n);
};

export { e as default };
//# sourceMappingURL=useFieldSubscription.js.map
